import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelCustomer } from '../types/label-customer.type';

/**
 * Delete Label Customer API
 */
export const deleteLabelCustomerValidationSchema = z.object({
  labelCustomerId: z.string().min(1, { message: 'Label Customer ID is required' }),
});

export type TDeleteLabelCustomerValidation = z.infer<typeof deleteLabelCustomerValidationSchema>;
export type TDeleteLabelCustomerPayload = TDeleteLabelCustomerValidation;
export type TDeleteLabelCustomerResponse = ApiResponse<TLabelCustomer>;

export const deleteLabelCustomer = async (
  payload: TDeleteLabelCustomerPayload
): Promise<TDeleteLabelCustomerResponse> => {
  const url = `/label-customer/${payload.labelCustomerId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Label Customer React-Query Hook
 */
type TUseDeleteLabelCustomerMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof deleteLabelCustomer, AxiosErrorCustom>;
};

export const useDeleteLabelCustomerMutation = ({ mutationConfigOptions }: TUseDeleteLabelCustomerMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: deleteLabelCustomer,
    ...restConfigOptions,
  });
};
